import React, { useState, useEffect, useRef, useCallback } from "react";
import BusinessDataService from "../services/BusinessService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const BusinessPr = (props) => {
  const [business, setBusiness] = useState([]);
  const businessRef = useRef();
  businessRef.current = business;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveBusiness = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    BusinessDataService.getAll(target)
      .then((response) => setBusiness(response.data || []))
      .catch((e) => { console.error(e); setBusiness([]); });
  }, [owner]);

  useEffect(() => { retrieveBusiness(); }, [retrieveBusiness]);

  const deleteBusiness = useCallback((rowIndex) => {
    const id = businessRef.current[rowIndex].id || businessRef.current[rowIndex]._id;
    BusinessDataService.remove(id)
      .then(() => {
        const newArr = [...businessRef.current];
        newArr.splice(rowIndex, 1);
        setBusiness(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/business/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/business/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = businessRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteBusiness(idx);
  }, [deleteBusiness]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={business}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default BusinessPr;
